import React from "react";
import "./TopInstructorsSection.css";
import { useTranslation } from "react-i18next";

const instructors = [
  {
    id: 1,
    name: "Gaurav Gupta",
    descriptionKey: "home.instructors.list.0.desc",
    rating: "4.9",
    students: "40K+",
    courses: "18",
    image: "/Image/Instructors/Gaurav Gupta.jpg",
    linkedin: "https://www.linkedin.com/in/gauravright85/",
  },
  {
    id: 2,
    name: "Anmol Goel",
    descriptionKey: "home.instructors.list.1.desc",
    rating: "4.8",
    students: "35K+",
    courses: "10",
    image: "/Image/Instructors/Anmol Goel.jpg",
    linkedin: "https://www.linkedin.com/in/-anmolgoel/",
  },
  {
    id: 3,
    name: "Dr. Somnath Mitra",
    descriptionKey: "home.instructors.list.2.desc",
    rating: "4.9",
    students: "28K+",
    courses: "12",
    image: "/Image/Instructors/Somnath Mitra.jpg",
    linkedin: "https://www.linkedin.com/in/somnathmitra1/",
  }
];


export default function TopInstructorsSection() {
  const { t } = useTranslation();

  return (
    <section className="top-instructors">
      <header className="top-instructors-header">
        <h2>
          {t("home.instructors.title")}
        </h2>

        <p>{t("home.instructors.subtitle")}</p>
      </header>


      <div className="instructors-row">
        {instructors.map((inst) => (
          <article
            className="instructor-card"
            key={inst.id}
            onClick={() => window.open(inst.linkedin, "_blank")}
            role="button"
            tabIndex={0}
          >
            <div className="avatar-wrap">
              <img src={inst.image} alt={inst.name} />

              <a
                href={inst.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="linkedin-badge"
                onClick={(e) => e.stopPropagation()}
              >
                in
              </a>

              <div className="rating-pill">
                <span>★</span> {inst.rating}
              </div>
            </div>

            <h3>{inst.name}</h3>
            <p className="description">{t(inst.descriptionKey)}</p>

            <div className="stats-card">
              <div>
                <strong>{inst.students}</strong>
                <span>{t("home.instructors.students")}</span>
              </div>
              <div>
                <strong>{inst.courses}</strong>
                <span>{t("home.instructors.courses")}</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
